<div class="password-request-reset-page">
  <app-request-reset-box></app-request-reset-box>
</div>
